import { Injectable } from '@angular/core';
import { DriveUpdateStore } from '../models/drive-update';
import { Accord } from 'src/app/modules/shared/models/accord';

@Injectable({
  providedIn: 'root'
})
export class DriveUpdateStoreService {

  accords: Accord[];
  driveUpdateCached: DriveUpdateStore[];
  prevDriveUpdateCached: DriveUpdateStore[];

  constructor() {
    this.accords = [];
    this.driveUpdateCached = [];
    this.prevDriveUpdateCached = [];
  }
}
